import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'

class CreateBloc {

    createChannel = new Subject()
    createDetailChannel = new Subject()
    submitChannel = new Subject()
    repository = new CreateRepository()

    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
        this.createDetailChannel.next({status: apiResponse.INITIAL})
        this.submitChannel.next({status: apiResponse.INITIAL})
    }

    fetchCreate = async (query) => {
        try {
            await this.repository.fetchCreate(query).then((result) => {
                this.createChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

    fetchCreateDetail = async (query) => {
        try {
            this.createDetailChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchCreateDetail(query).then((result) => {
                this.createDetailChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createDetailChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

    fetchSubmit = async (query) => {
        try {
            this.submitChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchSubmit(query).then((result) => {
                this.submitChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.submitChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

}

export default CreateBloc